import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import leftArrowIcon from '../assets/left.png';

// Shared design tokens (see src/pages/About.js for the full palette + rationale)
const displayFont = { fontFamily: "'Sora', ui-sans-serif, system-ui, sans-serif" };
const bodyFont = { fontFamily: "'Inter', ui-sans-serif, system-ui, sans-serif" };
const monoFont = { fontFamily: "'IBM Plex Mono', ui-monospace, SFMono-Regular, monospace" };

const SegmentationModel = () => {
  // استخدام useLocation لجلب البيانات الممررة عبر state من صفحة سابقة (مثل DiagnosisModel)
  const location = useLocation();
  // استخراج مسارات الصور. يتم توفير قيم افتراضية للحالات التي قد لا يتم فيها تمرير state.
  const {
    originalImage: initialOriginalImage,
    originalMask: initialOriginalMask,
    predictedImage: initialPredictedImage
  } = location.state || {};
  // حالات لتخزين وعرض مسارات الصور
  // تم تصحيح مسارات الصور الافتراضية إلى /public/back.jpg
  const [originalImageUrl] = useState(initialOriginalImage || "/public/back.jpg");
  const [originalMaskUrl] = useState(initialOriginalMask || "/public/back.jpg");
  const [predictedImageUrl] = useState(initialPredictedImage || "/public/back.jpg");

  const panels = [
    { label: 'Original Image', src: originalImageUrl, alt: 'Original scan' },
    { label: 'Original Mask', src: originalMaskUrl, alt: 'Original segmentation mask' },
    { label: 'Predicted Mask', src: predictedImageUrl, alt: 'Model-predicted segmentation' },
  ];

  return (
    <div className="flex flex-col min-h-screen bg-[#FAF9F6]" style={bodyFont}>
      <div className="flex-grow flex flex-col items-center p-4">
        {/* زر العودة للصفحة الرئيسية */}
        <Link to="/diagnosis-model" className="absolute top-4 left-4 z-20">
          <span className="flex items-center justify-center w-10 h-10 rounded-full bg-white border border-[#E4E1D8] shadow-sm">
            <img src={leftArrowIcon} alt="Back" className="w-5 h-5" />
          </span>
        </Link>
        <header className="text-2xl md:text-3xl font-bold text-[#0F3D3E] text-center mt-16 md:mt-16 mb-9" style={displayFont}>
          Segmentation Model Result
        </header>
        <div className="flex flex-wrap justify-center gap-6 w-full max-w-6xl">
          {panels.map((panel) => (
            <div key={panel.label} className="flex flex-col items-center bg-white p-6 rounded-xl border border-[#E4E1D8] shadow-sm flex-1 min-w-[280px] max-w-sm">
              <span className="text-xs font-semibold text-[#0F3D3E] uppercase tracking-wider mb-4" style={monoFont}>{panel.label}</span>
              <img
                src={panel.src}
                alt={panel.alt}
                className="w-full h-auto object-contain rounded-md border border-[#E4E1D8] max-h-[300px]"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default SegmentationModel;
